import { c as _c } from "react/compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import type { DisableModelIssuesReq, HTTPValidationError, MapValueReq, ResponseMessage, UnmapCategoryReq, UnmapIntentReq, UnmapTopicReq } from '../model';
import { customFetch } from '../../fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getMapIntentsUrl = () => {
  return `/api/v1/mappings/map-intents`;
};

/**
 * @summary Map Intents
 */
export const mapIntents = async (mapValueReq: MapValueReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getMapIntentsUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(mapValueReq)
  });
};
export const getMapIntentsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof mapIntents>>, TError, MapIntentsMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof mapIntents>>, TError, MapIntentsMutationVariables, TContext> => {
  const mutationKey = ['mapIntents'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapIntents>>, MapIntentsMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return mapIntents(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type MapIntentsMutationResult = NonNullable<Awaited<ReturnType<typeof mapIntents>>>;
export type MapIntentsMutationBody = MapValueReq;
export type MapIntentsMutationError = HTTPValidationError;
export type MapIntentsMutationVariables = {
  data: MapValueReq;
};

/**
 * @summary Map Intents
 */
export const useMapIntents = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getMapIntentsMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getUnmapIntentUrl = () => {
  return `/api/v1/mappings/unmap-intent`;
};

/**
 * @summary Unmap Intent
 */
export const unmapIntent = async (unmapIntentReq: UnmapIntentReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getUnmapIntentUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(unmapIntentReq)
  });
};
export const getUnmapIntentMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof unmapIntent>>, TError, UnmapIntentMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof unmapIntent>>, TError, UnmapIntentMutationVariables, TContext> => {
  const mutationKey = ['unmapIntent'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof unmapIntent>>, UnmapIntentMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return unmapIntent(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UnmapIntentMutationResult = NonNullable<Awaited<ReturnType<typeof unmapIntent>>>;
export type UnmapIntentMutationBody = UnmapIntentReq;
export type UnmapIntentMutationError = HTTPValidationError;
export type UnmapIntentMutationVariables = {
  data: UnmapIntentReq;
};

/**
 * @summary Unmap Intent
 */
export const useUnmapIntent = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUnmapIntentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getMapTopicsUrl = () => {
  return `/api/v1/mappings/map-topics`;
};

/**
 * @summary Map Topics
 */
export const mapTopics = async (mapValueReq: MapValueReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getMapTopicsUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(mapValueReq)
  });
};
export const getMapTopicsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof mapTopics>>, TError, MapTopicsMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof mapTopics>>, TError, MapTopicsMutationVariables, TContext> => {
  const mutationKey = ['mapTopics'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapTopics>>, MapTopicsMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return mapTopics(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type MapTopicsMutationResult = NonNullable<Awaited<ReturnType<typeof mapTopics>>>;
export type MapTopicsMutationBody = MapValueReq;
export type MapTopicsMutationError = HTTPValidationError;
export type MapTopicsMutationVariables = {
  data: MapValueReq;
};

/**
 * @summary Map Topics
 */
export const useMapTopics = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getMapTopicsMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getUnmapTopicUrl = () => {
  return `/api/v1/mappings/unmap-topic`;
};

/**
 * @summary Unmap Topic
 */
export const unmapTopic = async (unmapTopicReq: UnmapTopicReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getUnmapTopicUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(unmapTopicReq)
  });
};
export const getUnmapTopicMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof unmapTopic>>, TError, UnmapTopicMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof unmapTopic>>, TError, UnmapTopicMutationVariables, TContext> => {
  const mutationKey = ['unmapTopic'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof unmapTopic>>, UnmapTopicMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return unmapTopic(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UnmapTopicMutationResult = NonNullable<Awaited<ReturnType<typeof unmapTopic>>>;
export type UnmapTopicMutationBody = UnmapTopicReq;
export type UnmapTopicMutationError = HTTPValidationError;
export type UnmapTopicMutationVariables = {
  data: UnmapTopicReq;
};

/**
 * @summary Unmap Topic
 */
export const useUnmapTopic = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUnmapTopicMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getDisableModelIssuesUrl = () => {
  return `/api/v1/mappings/disable-model-issues`;
};

/**
 * @summary Disable Model Issues
 */
export const disableModelIssues = async (disableModelIssuesReq: DisableModelIssuesReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getDisableModelIssuesUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(disableModelIssuesReq)
  });
};
export const getDisableModelIssuesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof disableModelIssues>>, TError, DisableModelIssuesMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof disableModelIssues>>, TError, DisableModelIssuesMutationVariables, TContext> => {
  const mutationKey = ['disableModelIssues'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableModelIssues>>, DisableModelIssuesMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return disableModelIssues(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type DisableModelIssuesMutationResult = NonNullable<Awaited<ReturnType<typeof disableModelIssues>>>;
export type DisableModelIssuesMutationBody = DisableModelIssuesReq;
export type DisableModelIssuesMutationError = HTTPValidationError;
export type DisableModelIssuesMutationVariables = {
  data: DisableModelIssuesReq;
};

/**
 * @summary Disable Model Issues
 */
export const useDisableModelIssues = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getDisableModelIssuesMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getMapModelIssuesUrl = () => {
  return `/api/v1/mappings/map-model-issues`;
};

/**
 * @summary Map Model Issues
 */
export const mapModelIssues = async (mapValueReq: MapValueReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getMapModelIssuesUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(mapValueReq)
  });
};
export const getMapModelIssuesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof mapModelIssues>>, TError, MapModelIssuesMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof mapModelIssues>>, TError, MapModelIssuesMutationVariables, TContext> => {
  const mutationKey = ['mapModelIssues'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapModelIssues>>, MapModelIssuesMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return mapModelIssues(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type MapModelIssuesMutationResult = NonNullable<Awaited<ReturnType<typeof mapModelIssues>>>;
export type MapModelIssuesMutationBody = MapValueReq;
export type MapModelIssuesMutationError = HTTPValidationError;
export type MapModelIssuesMutationVariables = {
  data: MapValueReq;
};

/**
 * @summary Map Model Issues
 */
export const useMapModelIssues = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getMapModelIssuesMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getMapCategoriesUrl = () => {
  return `/api/v1/mappings/map-categories`;
};

/**
 * @summary Map Categories
 */
export const mapCategories = async (mapValueReq: MapValueReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getMapCategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(mapValueReq)
  });
};
export const getMapCategoriesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof mapCategories>>, TError, MapCategoriesMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof mapCategories>>, TError, MapCategoriesMutationVariables, TContext> => {
  const mutationKey = ['mapCategories'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapCategories>>, MapCategoriesMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return mapCategories(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type MapCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof mapCategories>>>;
export type MapCategoriesMutationBody = MapValueReq;
export type MapCategoriesMutationError = HTTPValidationError;
export type MapCategoriesMutationVariables = {
  data: MapValueReq;
};

/**
 * @summary Map Categories
 */
export const useMapCategories = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getMapCategoriesMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const getUnmapCategoryUrl = () => {
  return `/api/v1/mappings/unmap-category`;
};

/**
 * @summary Unmap Category
 */
export const unmapCategory = async (unmapCategoryReq: UnmapCategoryReq, options?: Parameters<typeof customFetch>[1]): Promise<ResponseMessage> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResponseMessage>(getUnmapCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(unmapCategoryReq)
  });
};
export const getUnmapCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof unmapCategory>>, TError, UnmapCategoryMutationVariables, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof unmapCategory>>, TError, UnmapCategoryMutationVariables, TContext> => {
  const mutationKey = ['unmapCategory'];
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof unmapCategory>>, UnmapCategoryMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return unmapCategory(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type UnmapCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof unmapCategory>>>;
export type UnmapCategoryMutationBody = UnmapCategoryReq;
export type UnmapCategoryMutationError = HTTPValidationError;
export type UnmapCategoryMutationVariables = {
  data: UnmapCategoryReq;
};

/**
 * @summary Unmap Category
 */
export const useUnmapCategory = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getUnmapCategoryMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};